'use client';
import { useState } from 'react';
import classNames from 'classnames';

import { Collapse, Icon } from '@/components';
import { currencyFormat } from '@/utils';
import style from './cartnavigation.module.scss';
import { TreezSpecial } from '@/types';
import { useFeaturedFlag } from '@/hooks';

const DiscountsInfo = ({
  specials,
  discounts,
  cartBackendError = false,
}: {
  specials?: TreezSpecial[];
  discounts: number;
  cartBackendError?: boolean;
}) => {
  const [isDiscountsOpen, setIsDiscountsOpen] = useState(false);
  const { isTaxAppliedMessage } = useFeaturedFlag();

  const getFormatedTitle = (title: string) => {
    const lowerCaseTitle = title.split('-').join(' ').toLowerCase();
    return lowerCaseTitle[0].toUpperCase() + lowerCaseTitle.slice(1);
  };

  if (isTaxAppliedMessage || cartBackendError) {
    const discountAmount = `-$${currencyFormat(discounts)}`;

    return (
      <div
        aria-label={`Discounts: ${discountAmount}`}
        className={style.footer__discount_section__discount_included}
        role="group"
      >
        <span className={style.heading}>Discounts</span>
        <span aria-hidden="true" className={style.grams}>
          {discountAmount}
        </span>
      </div>
    );
  }

  const discountAmount = `-$${currencyFormat(discounts)}`;

  return (
    <div className={style.footer__discount_section}>
      <button
        aria-controls="accordion-content-iWarning"
        aria-expanded={isDiscountsOpen}
        aria-label={`Discounts: ${discountAmount}. Click to ${
          isDiscountsOpen ? 'collapse' : 'expand'
        } details`}
        className={style.footer__discounts_btn}
        onClick={() => {
          setIsDiscountsOpen(prev => !prev);
        }}
      >
        <div className={style.heading_section}>
          <span className={style.heading}>Discounts</span>
          <Icon
            aria-hidden="true"
            name={isDiscountsOpen ? 'angle-up' : 'angle-down'}
          />
        </div>

        <span aria-hidden="true" className={style.grams}>
          {discountAmount}
        </span>
      </button>
      <Collapse
        aria-label="Discount details"
        className={classNames('accordion__content', {
          ['accordion__content_collapse']: isDiscountsOpen,
        })}
        id="accordion-content-iWarning"
        isOpen={isDiscountsOpen}
        role="region"
      >
        <div className={style.footer__discounts_container}>
          {specials?.map((item, index) => {
            const itemTitle = getFormatedTitle(item?.title);
            const itemAmount = `-$${currencyFormat(item?.amount)}`;

            return (
              <div
                aria-label={`${itemTitle}: ${itemAmount}`}
                className={style.discount_item}
                key={index}
                role="group"
              >
                <span>{itemTitle}</span>
                <span aria-hidden="true" className={style.discount_item_amount}>
                  {itemAmount}
                </span>
              </div>
            );
          })}
        </div>
      </Collapse>
    </div>
  );
};

export default DiscountsInfo;
